import React from 'react';

export function KpiCard({ label, value, sub, icon: Icon, testId }) {
  return (
    <div data-testid={testId || `kpi-${label.toLowerCase().replace(/\s+/g, '-')}`} className="rounded-2xl bg-kelate-surface p-4 shadow-[0_1px_4px_rgba(81,68,55,0.08)]">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wider text-kelate-soft">{label}</span>
        {Icon && <Icon size={16} className="text-kelate-wood" />}
      </div>
      <div className="mt-2 text-2xl font-semibold text-kelate-ink">{value}</div>
      {sub && <div className="mt-1 text-xs text-kelate-soft">{sub}</div>}
    </div>
  );
}
